import { cpib2GatewaySpareParts } from "./Cpib2GatewaySpareParts";
import { epalGatewaySpareParts } from "./epalGatewaySpareParts";
import { epalDeviceSpareParts } from "./epalDeviceSpareParts"

export class spareParts {
    PoNumber: string;
    UnitNumber: string;
    SaveCpib2: boolean = false;
    SaveCpib2Sim: boolean = false;
    CPIB2GatewaySparePartsdetails: cpib2GatewaySpareParts; 
    SaveEpalGateway: boolean = false;
    SaveEpalGatewaySim : boolean = false;
    EpalGatewaySparePartsdetails: epalGatewaySpareParts;
    SaveEpalDevice: boolean = false;
    EpalDeviceSparePartsdetails: epalDeviceSpareParts; 
}